import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import FlowLeftNav from './components/FlowLeftNav';
import Flow from './components/Flow';
import { FlowProvider } from './components/Context';
import { fetchAndStoreIpAddress } from './services/ipService';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
var measurementId = 'DC-15460437';
function getCookie(name) {
    var m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? m[2] : "";
}
export default function App(_a) {
    var apiUrl = _a.apiUrl, layout = _a.layout;
    useEffect(function () {
        var leadId = getCookie("LeadId");
        var Startup = window.Startup;
        if (leadId && Startup) {
            Startup.Store("userID", leadId);
            Startup.AfterResult(function (r) {
                if (r && r.fraud_chance >= 90) { }
            });
            Startup.AfterFailure(function () { });
        }
    }, []);
    useEffect(function () {
        ReactGA.initialize(measurementId);
    }, []);
    useEffect(function () {
        fetchAndStoreIpAddress().catch(function (error) {
            console.debug("Failed to capture IP address:", error);
        });
    }, []);
    if (layout === "leftnav") {
        require("../../../css/naf/dynamic-form-left-nav-page.min.css");
    }
    else {
        require("../../../css/naf/dynamic-form-standard-questions.min.css");
    }
    return (_jsx(React.StrictMode, { children: _jsx(FlowProvider, { apiUrl: apiUrl, children: layout === "leftnav" ? _jsx(FlowLeftNav, {}) : _jsx(Flow, {}) }) }));
}
